module.exports = __webpack_public_path__ + "static/media/manage_deck.e8a79c58.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/swipe/manage_deck.mp4
// module id = 270
// module chunks = 0